export default __webpack_public_path__ + "static/media/Versions - Comparisons_05.0796baea.jpg";